import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.TreeTable,
  title: 'Tree Table',
  category: ComponentCategory.General,
};
